module.exports = __webpack_public_path__ + "static/img/icons_comission_fees_blue.baee98b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_comission_fees_blue.svg
// module id = 0nNw
// module chunks = 1